import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMember } from "../api/membersApi";
import { queryKeys } from "../lib/queryKeys";

export function useDeleteMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteMember(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
